import React, { useContext } from 'react';
import { useEffect } from 'react';
import { ToolbarContext } from '../../contexts/toolbar-context';
import { useState } from 'react';
import { useCallback } from 'react';
import {usePermissionsQueryQuery} from "../../generated/graphql";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    FormControlLabel,
    IconButton,
    TextField, Tooltip, Typography
} from "@mui/material";
import WaitSpinner from "../../components/wait-spinner";
import {useParams} from "react-router";
import { Check } from '@mui/icons-material';
import { Cancel } from '@mui/icons-material';

// eslint-disable-next-line react/display-name
export function RoleForm({diaForm,readOnly}) {
    const {values,errors,handleSubmit,onChange,isDirty,setValue,status} = diaForm;
    const [permissions,setPermissions] = useState([]);
    const id = useParams().id;
    const isNew = id === 'new';
    const toolbarContext = useContext(ToolbarContext);
    const permissionQuery = usePermissionsQueryQuery();
    const doSave = () => {
        handleSubmit();
    };
    const field = {
        onChange: onChange,
        readOnly:readOnly
    };
    const baseUrl = '/settings/role';
    useEffect(() => {
        const buttons = [];
        if(!readOnly && status!='loading') {
            buttons.push({
                type: 'button',
                icon: 'save',
                tooltip: 'Save',
                callback: doSave,
                label: 'Save',
                style: 'primary',
                disabled: !isDirty
            });
        }
        toolbarContext.setSecondary(
            {
                primaryUrl:baseUrl,
                title:(!isNew ? 'Role: '+values?.name : 'New Role'),
                secondary:buttons,
                secondaryUrl: isNew?'new':values?.id
            });
    }, [id, isDirty, status,values.name]);

    useEffect(()=>{
        const newPermissions = {};
        if(!permissionQuery?.data?.permissions?.data) return;
        permissionQuery.data?.permissions?.data.forEach((permission)=>{
            if(!newPermissions[permission.category]) newPermissions[permission.category] = [];
            newPermissions[permission.category].push(permission);
        });
        const permissionArray = [];
        const arr = Object.entries(newPermissions).sort(([k], [k2]) => k < k2 ? -1 : 1);
        console.log('SORTED',arr);
        arr.forEach(([k,v])=>{
            const p = {label: k, values: v};
            permissionArray.push(p);
        });
        setPermissions(permissionArray);
    },[permissionQuery?.data?.permissions?.data]);

    const selectedPermissions = {};

    values?.permissions && values.permissions.map((v)=>{
        selectedPermissions[v.id] = true;
    });
    const togglePermission = useCallback((id)=>{
        if(readOnly) return;
        setValue('permissions',(values)=>{
            const newValues = [];
            let found = false;
            values.forEach(value=>{
                if(value.id==id) {
                    found = true;
                } else {
                    newValues.push(value);
                }
            });
            if(!found) {
                permissionQuery?.data?.permissions?.data.forEach((value)=> {
                    if(value.id==id) {
                        newValues.push(value);
                    }
                })
                console.log('not found');
            }
            return newValues;
        });
    },[permissionQuery?.data?.permissions?.data,readOnly]);
    const toggleAll = useCallback((block,enable)=>{
        if(enable) {
            setValue('permissions',(currentPermissions)=>{
                const newValues = [...currentPermissions];
                block.values.forEach((permissionToChange)=>{
                    let found = false;
                    currentPermissions.forEach((value)=> {
                        if(value.id==permissionToChange.id) {
                            found = true;
                        }
                    })
                    if(!found) {
                        newValues.push(permissionToChange);
                    }
                });
                return newValues;
            });
        } else {
            const toRemove = block.values.map((v)=>v.id);
            setValue('permissions',(currentPermissions)=>{
                const newValues = [];
                currentPermissions.forEach((currentPermission)=>{
                    if(toRemove.indexOf(currentPermission.id)>-1) {
                        return;
                    }
                    newValues.push(currentPermission);
                });
                return newValues;
            });
        }
    },[]);
    const permissionHtml = permissions.map((val)=>{
        let isAllChecked = true;
        val.values.forEach((value)=>isAllChecked &= selectedPermissions[value.id]);
        return <Card key={val.label} variant="outlined">
            <CardContent>
                <Typography variant="h6" component="div">
                    {val.label} 
                    <Tooltip title={isAllChecked?'Clear all':'Select All'}>
                    <IconButton onClick={()=>toggleAll(val,!isAllChecked)} color="primary">{isAllChecked?<Cancel/>:<Check/>}</IconButton>
                    </Tooltip>
                </Typography>
                <div className="checkbox-columns">
                    {val.values.map((value)=>
                        <FormControlLabel key={value.id} control={<Checkbox onChange={()=>togglePermission(value.id)} checked={selectedPermissions[value.id]??false} />} label={value.name}
                        style={{width:'300px'}}
                        />
                    )}
                </div>
            </CardContent>
        </Card>;
    })
    const spinner = (diaForm.status != 'ready' ||id!=values.id)? <WaitSpinner variant="overlay" />:null;
    return (
        <Accordion defaultExpanded={true}>
            {spinner}
            <AccordionSummary>Role</AccordionSummary>
            <AccordionDetails>
                <TextField  {...field} name="name" value={values.name} error={!!errors?.name} label="Name of Role"/>
                <h4>Permissions</h4>
                {permissionHtml}
            </AccordionDetails>
        </Accordion>
    );
}



